import React, { useState } from "react";
import { Modal, Button } from "antd";
import Draggable from "react-draggable";
import { CloseOutlined } from "@ant-design/icons";
import StepsWizardWrapper from "../../../components/scheduling/StepsWizard.style";
import EmployeeSchedulingContent from "../../../components/scheduling/EmployeeSchedulingContent";
import { useSelector } from "react-redux";

const AddEmployeeScheduling = (props) => {
  const {
    visible,
    handleCancel,
    activeEmployee,
    reload,
    currentDate,
    employeePatients,
    initialValues,
  } = props;

  const [disabled, setDisabled] = useState(true);
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  return (
    <Modal
      maskClosable={false}
      title={null}
      destroyOnClose={true}
      width={"max-content"}
      styles={{
        body: {
          padding: "2px 0 0 0",
        },
      }}
      closable={false}
      open={visible}
      onCancel={handleCancel}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      footer={null}
    >
      <StepsWizardWrapper direction={currentAppLocale.direction}>
        <div
          className="steps"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={handleCancel}
          />
        </div>
        <div className="inner">
          <EmployeeSchedulingContent
            activeEmployee={activeEmployee}
            closeModal={handleCancel}
            reload={reload}
            currentDate={currentDate}
            employeePatients={employeePatients}
            initialValues={initialValues}
          />
        </div>
      </StepsWizardWrapper>
    </Modal>
  );
};

export default AddEmployeeScheduling;
